export const width=1516;export const height=147;export default{width:width,height:height};